import axios from 'axios';

/**
 * Pull a field-level `name` error out of a saved-views API failure. Covers
 * both DRF shapes: `{'name': 'msg'}` (raised from our IntegrityError path)
 * and `{'name': ['msg']}` (raised from serializer.validate). Returns null
 * for anything else so callers can fall back to generic toasts.
 */
export function extractNameError(err: unknown): string | null {
  if (!axios.isAxiosError(err) || err.response?.status !== 400) return null;
  const data = err.response.data as { name?: unknown };
  if (typeof data?.name === 'string') return data.name;
  if (Array.isArray(data?.name) && typeof data.name[0] === 'string') return data.name[0];
  return null;
}
